import { StatusConstants } from "./apiStatusConstants";

const FALLBACK_HISTORY_PERSIST_WARNING =
  "Credential was updated but history could not be saved. Operations has been notified.";

function getCredentialDetails(response: any): any[] {
  if (Array.isArray(response?.messageStatus?.details)) {
    return response.messageStatus.details;
  }
  if (Array.isArray(response?.details)) {
    return response.details;
  }
  return [];
}

/** True for clean success (messageStatus null) or soft-warning-only history persist lag. */
export function isCredentialUpdateSuccess(response: any): boolean {
  if (response?.messageStatus === null) {
    return true;
  }
  if (response?.messageStatus == null || typeof response.messageStatus !== "object") {
    return false;
  }
  const details = Array.isArray(response.messageStatus.details)
    ? response.messageStatus.details
    : [];
  if (details.length === 0) {
    return false;
  }
  return details.every(
    (d: { code?: string }) =>
      d?.code === StatusConstants.CREDENTIAL_HISTORY_PERSIST_WARNING_CODE
  );
}

/** API description for history-persist soft warning, or null if none. */
export function getCredentialHistoryPersistWarning(response: any): string | null {
  const warn = getCredentialDetails(response).find(
    (d: { code?: string; description?: string }) =>
      d?.code === StatusConstants.CREDENTIAL_HISTORY_PERSIST_WARNING_CODE
  );
  if (!warn) {
    return null;
  }
  const desc = String(warn.description ?? "").trim();
  return desc || FALLBACK_HISTORY_PERSIST_WARNING;
}
